<template>
    <header class="site-header" v-if="!Edicao">
        <div class="logo">

            <img src="@/assets/logoHeader.png" v-if="nomeEmpresa == 'BRITECH' || nomeEmpresa == 'DNWAYS_DEMO_Y' || nomeEmpresa == 'DNWAYS_DEMO_X'" style="filter: invert(60%);" />
            <img src="@/assets/dnways.png" v-if="nomeEmpresa == 'Vortex'" style="width: 100%; height: 100%;" />
            <img src="@/assets/logoActual_v2.png" v-if="nomeEmpresa == 'ACTUAL'" style="width: 90%; height: 90%;" />
            <img src="@/assets/logogenial.png" v-if="nomeEmpresa == 'GENIAL'" style="width: 100%; height: 100%;" />
            <img src="@/assets/logoHeader_rji.png" v-if="nomeEmpresa == 'RJI'" />
            <img src="@/assets/logoLastro.jpg" v-if="nomeEmpresa == 'Lastro'" style="width: 100%; height: 100%;" />

        </div>

        <div v-if="menuAberto" class="sidebar">
            <button class="close-btn"  @click="menuAberto = false">×</button>
            <h3>Cadastro Pessoa Jurídica</h3>
            <ul>
                <li><a href="javascript:;" :class="{ active: tab == 0, preenchido: tab > 0, ativo: maxTab >= 0, 'current-section': tab == 0 }"
                            @click="selectTab(0)">
                            Dados da Empresa
                        </a></li>
                <li> <a href="javascript:;"  :class="{ active: tab == 1, preenchido: tab > 1, ativo: maxTab >= 1, 'current-section': tab == 1 }"
                            @click="selectTab(1)">
                            Procuradores
                        </a></li>
                <li><a href="javascript:;"  :class="{ active: tab == 2, preenchido: tab > 2, ativo: maxTab >= 2, 'current-section': tab == 2 }"
                            @click="selectTab(2)">
                            Representantes
                        </a></li>
                <li><a href="javascript:;"  :class="{ active: tab == 3, preenchido: tab > 3, ativo: maxTab >= 3, 'current-section': tab == 3 }"
                            @click="selectTab(3)">
                            Dados Financeiros
                        </a></li>
                <li><a v-if="nomeEmpresa != 'GENIAL'" href="javascript:;" 
                            :class="{ active: tab == 4, preenchido: tab > 4, ativo: maxTab >= 5, 'current-section': tab == 4 }" @click="selectTab(4)">
                            Dados Bancários
                        </a></li>
                <li><a href="javascript:;" :class="{ active: tab == 5, preenchido: tab > 5, ativo: maxTab >= 5, 'current-section': tab == 5 }"
                            @click="selectTab(5)">
                            Endereço
                        </a></li>
                <li><a href="javascript:;"  :class="{ active: tab == 6, preenchido: tab > 6, ativo: maxTab >= 6, 'current-section': tab == 6 }"
                            @click="selectTab(6)">
                            Upload de Documentos
                        </a></li>
                <li><a href="javascript:;" :class="{ active: tab == 7, preenchido: tab > 7, ativo: maxTab >= 7, 'current-section': tab == 7 }"
                            @click="selectTab(7)">
                            Declarações
                        </a></li>
                <li><a href="javascript:;" :class="{ active: tab == 8, ativo: maxTab >= 8, 'current-section': tab == 8  }" @click="selectTab(8)">
                            Produtos
                        </a></li>
                <li><a href="javascript:;" @click="logoff" class="logout">Sair</a></li>
            </ul>
        </div>

        <nav class="navigation">
            <ul>
                <li><button type="button" v-if="configuracaoToken != 'S'" class="button button-light" @click="alterarSenha()"
                        style="cursor: pointer;">Alterar senha</button></li>
                <li><button type="button" @click="logoff" style="cursor: pointer;" class="submit-button">Logoff</button>
                </li>
            </ul>
        </nav>
    </header>

        <div v-if="!Edicao" class="navigation-mobile" style="display: none">
            <button class="menu-button" @click="menuAberto = !menuAberto">
            ☰
            </button>
            <span class="rota">
                {{nomeMenu}}
            </span>
        </div>


    <div class="container">
        <div class="header">
            <h2 v-if="!Edicao" class="form-header">Cadastro</h2>
            <div class="info__headers" v-if="!Edicao">
                <div class="info__resumo">
                    <div class="navegacao">
                        <a href="javascript:;" class="link" :class="{ active: tab == 0, preenchido: tab > 0 }"
                            @click="selectTab(0)">
                            Dados da Empresa
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 1, preenchido: tab > 1, inativo: maxTab >= 1 }"
                            @click="selectTab(1)">
                            Procuradores
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 2, preenchido: tab > 2, inativo: maxTab >= 2 }"
                            @click="selectTab(2)">
                            Representantes
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 3, preenchido: tab > 3, inativo: maxTab >= 3 }"
                            @click="selectTab(3)">
                            Dados Financeiros
                        </a>
                        <a v-if="nomeEmpresa != 'GENIAL'" href="javascript:;" class="link"
                            :class="{ active: tab == 4, preenchido: tab > 4, inativo: maxTab >= 4 }" @click="selectTab(4)">
                            Dados Bancários
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 5, preenchido: tab > 5, inativo: maxTab >= 5 }"
                            @click="selectTab(5)">
                            Endereço
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 6, preenchido: tab > 6, inativo: maxTab >= 6 }"
                            @click="selectTab(6)">
                            Upload de Documentos
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 7, preenchido: tab > 7, inativo: maxTab >= 7 }"
                            @click="selectTab(7)">
                            Declarações
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 8, inativo: maxTab >= 8 }" @click="selectTab(8)">
                            Produtos
                        </a>
                    </div>
                </div>
            </div>
            <div v-if="tab == 0" class="headerAtivo">
                <DadosEmpresa v-if="informacoesEmpresa" ref="form_0" :Edicao="Edicao" />
            </div>
            <div v-if="tab == 1" class="headerAtivo">
                <Procuradores :Edicao="Edicao" ref="form_1" />
            </div>
            <div v-if="tab == 2" class="headerAtivo">
                <Representantes :Edicao="Edicao" ref="form_2" />
            </div>
            <div v-if="tab == 3 && informacoesFinanceiras" class="headerAtivo">
                <DadosFinanceiros v-if="informacoesFinanceiras" ref="form_3" :informacoesFinanceiras="informacoesFinanceiras"
                    :Edicao="Edicao" />
                <div v-if="!informacoesFinanceiras" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 4" class="headerAtivo">
                <DadosBancarios v-if="infoBancarios" ref="form_4" :Edicao="Edicao" />
                <div v-if="!infoBancarios" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 5" class="headerAtivo">
                <Endereco v-if="informacoesEndereco" ref="form_5" :informacoesEndereco="informacoesEndereco" :Edicao="Edicao" />
                <div v-if="!informacoesEndereco" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 6" class="headerAtivo">
                <UploadDocumentos :Edicao="Edicao" ref="form_6" />
            </div>
            <div v-if="tab == 7" class="headerAtivo">
                <Declaracoes v-if="informacoesDeclaracoes" ref="form_7" :informacoesDeclaracoes="informacoesDeclaracoes"
                    :Edicao="Edicao" />
                <div v-if="!informacoesDeclaracoes" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 8" class="headerAtivo">
                <div><Produtos :Edicao="Edicao" ref="form_8" /></div>
            </div>

        <div class="footerFormulario">
            <div class="buttonsAcoes">
                <button class="btnDefault" @click="validarFormularioAtual">{{this.Edicao ? 'Salvar' : 'Salvar e continuar depois'}} </button>
                <button class="btnBlue btnAvancar" v-if="!Edicao" @click="proximaEtapa">{{this.tab == 8 ? 'Concluir' : 'Avançar'}}</button>
            </div>
        </div>

        </div>
    </div>
    <ModalAlterarSenha />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DadosEmpresa from './DadosEmpresa.vue';
import Representantes from './Representantes.vue';
import Procuradores from './Procuradores.vue'
import DadosFinanceiros from './DadosFinanceiros.vue';
import DadosBancarios from './DadosBancarios.vue';
import Endereco from './Endereco.vue';
import UploadDocumentos from './UploadDocumentos.vue';
import Declaracoes from './Declaracoes.vue';
import Produtos from './Produtos.vue';
import api from '@/api/axios';
import ModalAlterarSenha from '../AlterarSenha/ModalAlterarSenha.vue'
export default {
    components: {
        DadosEmpresa,
        Procuradores,
        Representantes,
        DadosFinanceiros,
        DadosBancarios,
        Endereco,
        UploadDocumentos,
        Declaracoes,
        Produtos,
        ModalAlterarSenha
    },
    name: 'CadastroPJ_Passo_1',
    props: ['Edicao', 'BloquearSalvarIsolado'],
    
    computed: {
        ...mapGetters({
            user: 'auth/user',
            infoEmpresa: 'GET_PJ_INFO_EMPRESA',
            infoComplementoEmpresa: 'GET_PJ_INFO_COMPLEMENTO_EMPRESA',
            infoFinanceiras: 'GET_PJ_INFO_FINANCEIRA_EMPRESA',
            infoBancarios: 'GET_PJ_INFO_BANCARIOS',
            infoEndereco: 'GET_PJ_INFO_ENDERECO',
            infoDeclaracoes: 'GET_PJ_INFO_DECLARACOES',
            salvarInformacoesPJ: 'GET_PJ_SALVAR_INFO',
            enviarCadastro: 'GET_ENVIAR_CADASTRO',
            ObjSalvarInformacoesEmpresa: 'GET_PJ_SALVAR_INFO_EMPRESA',
            ObjSalvarInformacoesComplementoEmpresa: 'GET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA',
            ObjSalvarInformacoesComplementoSocios: 'GET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS',
            ObjSalvarInformacoesFinanceiro: 'GET_PJ_SALVAR_INFO_FINANCEIRO',
            ObjSalvarInformacoesBancarias: 'GET_PJ_SALVAR_INFO_BANCARIAS',
            ObjSalvarInformacoesBancariasAdicional: 'GET_PJ_SALVAR_INFO_BANCARIAS_ADICIONAL',
            ObjSalvarInformacoesEndereco: 'GET_PJ_SALVAR_INFO_ENDERECO',
            ObjSalvarInformacoesDeclaracoes: 'GET_PJ_SALVAR_INFO_DECLARACOES',
            ObjSalvarInformacoesUploadArquivos: 'GET_SALVAR_INFO_UPLOAD',
            ObjSalvarQuestionario: 'GET_SALVAR_QUESTIONARIO',
            salvarObjConcluir: 'GET_FICHA_CONCLUIR',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            etapasConcluidas: 'GET_ETAPA_CONCLUIDA',
            salvarObjDispensaQuestionario: 'GET_PF_PJ_SALVAR_INFO_DISPENSA',
            desabilitarNotificacao: 'GET_SALVAR_INFO_DES_NOTIFICACAO',
            getConfiguracoes: 'GET_CONFIGURACOES',
        },),
        salvouTodasAbas() {
            const { gravarDados } = this;
            return Object.values(gravarDados).every(value => value === 1);
        },
        nomeMenu() {
            const menus = [
                "Dados da Empresa",
                "Procuradores",
                "Representantes",
                "Dados Financeiros",
                "Dados Bancários",
                "Endereço",
                "Upload de Documentos",
                "Declarações",
                "Produtos",
            ];
            return menus[this.tab] || "Menu Desconhecido";
        },
    },
    data() {
        return {
            menuAberto: false,
            maxTab: 0,
            isLoading: true,
            color: '#3b8070',
            configuracaoToken: 'n',
            solicitouProximaEtapa: false,
            gravarDados: {
                salvarInformacoesPJ: 0,
                salvarComplementoEmpresa: 0,
                salvarComplementoSocios: 0,
                salvarDadosFinanceiro: 0,
                salvarDadosBancariosPrincipal: 0,
                salvarDadosBancariosAdicional: 0,
                salvarDadosEndereco: 0,
                salvarDadosDeclaracoes: 0,
                salvarInformacoesUpload: 0,
                salvarInformacoesDispensaQuestionario: 0,
                salvarQuestionario: 0,
            },
            nomeEmpresa: '',
            tab: 0,
            informacoesEmpresa: null,
            informacoesFinanceiras: this.infoFinanceiras,
            informacoesDeclaracoes: this.infoDeclaracoes,
            informacoesEndereco: null
        }
    },
    created() {
        this.obterDados();
        this.$store.commit('SET_FICHA_CONCLUIR', false);
    },
    async mounted() {
        await this.fetchConfiguracao(['Modo de autenticação', 'Obrigatoriedade Emissor de Ordem']);

        this.configuracaoToken = this.getConfiguracoes('Modo de autenticação')?.Valor != '2' ? 'N' : 'S';
        
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        if (!this.Edicao) {
            this.$store.commit('SET_ETAPA_CADASTRO', 0);
            this.executaProximaEtapa();
        } else {
            this.tab = this.etapaCadastro;

            if(this.maxTab < this.tab){
                this.maxTab = this.tab;
            }
        }
        
        if(this.infoEmpresa != null)
            this.informacoesEmpresa = this.infoEmpresa;

        if(this.infoFinanceiras != null)
            this.informacoesFinanceiras = this.infoFinanceiras;

        if(this.infoEndereco != null)
            this.informacoesEndereco = this.infoEndereco;

        if(this.infoDeclaracoes != null)
            this.informacoesDeclaracoes = this.infoDeclaracoes;
    },
    methods: {
         ...mapActions({
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        async validarFormularioAtual(){
            const refName = `form_${this.tab}`;
            const componente = this.$refs[refName];
            if(await this.validaComponente(refName, componente)){
                if (componente?.salvarInformacoes) {
                    componente.salvarInformacoes();
                }else if(this.BloquearSalvarIsolado){
                    this.$store.commit('SET_PJ_SALVAR_INFO', true);
                }
            }
        },
        async validaComponente(refName, componente){
            if(refName == 'form_1' || refName == 'form_2' ){
                return true;
            }

            if(!this.Edicao){
                return true;
            }

            if(componente?.validarFormulario && await componente.validarFormulario(true)){
                return true;
            }

            return false;
        },
        proximaEtapa(){
            const refName = `form_${this.tab}`;
            const componente = this.$refs[refName];
            if (componente?.proximaEtapa) {
                componente.proximaEtapa();
            }
        },
        async obterDados() {
            await this.$store.dispatch('FETCH_PJ_INFO_EMPRESA');
            await this.$store.dispatch('FETCH_PJ_INFO_COMPLEMENTO_EMPRESA');
            await this.$store.dispatch('FETCH_PJ_INFO_COMPLEMENTO_SOCIOS');
            await this.$store.dispatch('FETCH_PJ_INFO_FINANCEIRA');
            await this.$store.dispatch('FETCH_PJ_INFO_BANCARIOS');
            await this.$store.dispatch('FETCH_PJ_INFO_ENDERECO');
            await this.$store.dispatch('FETCH_PJ_INFO_DECLARACOES');
            await this.$store.dispatch('FETCH_CONSULTA_BANCOS');
            await this.$store.dispatch('FETCH_CONSULTA_PAISES');
            await this.$store.dispatch('FETCH_CONSULTA_ATIVIDADES', 'PJ');
            await this.$store.dispatch('FETCH_QUESTIONARIO_BUSCAR_QUESTOES');
            await this.$store.commit('SET_PJ_SALVAR_INFO_BANCARIAS', null);
            await this.$store.commit('SET_PJ_SALVAR_INFO_BANCARIAS_ADICIONAL', null);
            await this.$store.dispatch('FETCH_BUSCA_LISTA_MOTIVO_DISPENSA');
            await this.$store.dispatch('FETCH_CONSULTA_DISCLAIMER');
            await this.$store.dispatch('FETCH_CONSULTA_TIPOS_CLIENTES_PJ');
            await this.$store.dispatch('FETCH_CONSULTA_TIPOS_INVESTIDORES');
            await this.$store.dispatch('FETCH_CONSULTA_NATUREZA_JURIDICA');
            
        },
        formatarValorFinanceiro(valorString) {

            if (valorString === null || valorString === undefined) {
                return 0;
            }
    
            if (typeof valorString !== 'string') {
                    valorString = String(valorString);
            }

            const valorNumerico = parseFloat(
                valorString
                    .replace(/\s/g, '') // remove todos os espaços (inclusive \u00A0)
                    .replace('R$', '')
                    .replace(/\./g, '')
                    .replace(',', '.')
            );

            return isNaN(valorNumerico) ? 0 : valorNumerico;
        },
        selectTab(tabSelected) {
            if (tabSelected < this.tab || tabSelected <= this.maxTab) {
                this.tab = tabSelected;

                if(this.maxTab < this.tab){
                    this.maxTab = this.tab;
                }

                this.$store.commit('SET_ETAPA_CADASTRO', this.tab)
            }
            this.menuAberto = false;
        },
        alterarSenha() {
            this.$store.commit('SET_ABRIR_ALTERAR_SENHA', true)
        },
        logoff() {
            this.$store.dispatch('auth/logout');
        },
        async salvarConcluir() {
            if (this.salvarInformacoesPJ == true && this.salvarObjConcluir == true) {
                 
                this.$store.commit('SET_PJ_SALVAR_INFO', false);
                this.$store.commit('SET_FICHA_CONCLUIR', false);
                this.$store.commit('SET_ENVIAR_CADASTRO', false);
                

                const data = {
                    RenovacaoCadastral: this.BloquearSalvarIsolado
                };

                await api
                    .post('/PessoaJuridica/ConcluirCadastro', data)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            if(this.user.StatusCadastro > 1){

                                this.$swal({
                                    icon: 'warning',
                                    title: 'Cadastro atualizado',
                                    text: 'As informações serão revisadas pela equipe responsável e você poderá acompanhar essa revisão pelo status.',
                                });

                                this.user.StatusCadastro = 4;
                                this.$store.commit('SET_USER', this.user);

                            }else{

                            this.$swal({
                                icon: 'success',
                                title: 'Cadastro enviado para análise!',
                                text: 'Em até 48h úteis, a empresa receberá novidades no e-mail informado.',
                            }).then((result) => {
                                if (result.value) {
                                    this.logoff();
                                }
                            });
                            }
                        }
                    })
                    .catch((error) => {
                        this.$store.commit('SET_PJ_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            } else {
                this.$store.commit('SET_PJ_SALVAR_INFO', false);
                if (this.desabilitarNotificacao == true) {
                    this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', false);
                } else if (!this.Edicao) {
                    this.$swal({
                        icon: 'success',
                        title: 'Alterações realizadas com sucesso!',
                        text: 'Dados informados foram salvos com sucesso.',
                    });
                }
                this.obterDados();
            }
        },
        async salvarQuestionarioAsync(){
            if (this.salvarInformacoesPJ) {
                if (this.ObjSalvarQuestionario == null || (this.tab <= 7 && !this.Edicao)) {
                    this.gravarDados.salvarQuestionario = 1;
                    return;
                } else {
                await api
                .post('/suitability', this.ObjSalvarQuestionario)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$store.commit('SET_SALVAR_QUESTIONARIO', null);
                        this.gravarDados.salvarQuestionario = 1;
                         this.$store.commit("SET_MODAL_QUESTIONARIO", false);

                        if(!this.BloquearSalvarIsolado && !this.Edicao){
                            this.$swal({
                                icon: 'success',
                                title: 'Formulário preenchido com sucesso!',
                                text: 'Dados informados foram salvos com sucesso.',
                            });
                        }

                        this.$store.dispatch('FETCH_PERFIL_CLIENTE');

                        if(this.Edicao)
                        {
                            if(this.user.StatusCadastro == 3 
                            && !this.user.PermiteLoginEmRevisao)
                            {
                                this.logoff();
                            }
                            else
                            {
                                this.user.StatusCadastro = 4;
                            }
                        }

                    }else{
                      this.gravarDados.salvarQuestionario = 2;
                    }
                })
                .catch((error) => {
                    this.gravarDados.salvarQuestionario = 2;
                    console.log(error);
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.descricao}`,
                    });
                });
            }
            }
        },
        async salvarInformacoesDispensaQuestionario() {
            if (this.salvarInformacoesPJ) {
                 
                if (this.salvarObjDispensaQuestionario == null || (!this.Edicao && this.tab  <= 7)) {
                    this.gravarDados.salvarInformacoesDispensaQuestionario = 1;
                    return;
                } else {
                    await api
                        .post('/suitability/dispensa-questionario', this.salvarObjDispensaQuestionario)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.commit('SET_PF_PJ_SALVAR_INFO_DISPENSA', null);
                                this.$store.dispatch('FETCH_PERFIL_CLIENTE');


                                this.gravarDados.salvarInformacoesDispensaQuestionario = 1;
                                return;
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarInformacoesDispensaQuestionario = 2;
                            this.$store.commit('SET_PF_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Produtos, sessão Dispensa de Questionário.',
                                text: `${error.response.data.data[0]}`,
                            });
                        });
                }

            }
        },
        async salvarInformacoesUpload() {
            if (!this.salvarInformacoesPJ) {
                return;
            }
             
            if (this.ObjSalvarInformacoesUploadArquivos == null || (!this.Edicao && this.tab  <= 5)) {
                this.gravarDados.salvarInformacoesUpload = 1;
                return;
            } else {
                
                const data = {
                    documentos: this.ObjSalvarInformacoesUploadArquivos
                };
                await api
                    .post('/cliente/documentos', data)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO');
                            this.gravarDados.salvarInformacoesUpload = 1;
                            this.$store.commit('SET_SALVAR_INFO_UPLOAD', null);
                        }
                    })
                    .catch((error) => {
                        this.gravarDados.salvarInformacoesUpload = 2;
                        this.$store.commit('SET_PJ_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Falha ao realizar upload de documentos',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        },
        async salvarDadosDeclaracoes() {
            if (!this.salvarInformacoesPJ) {
                return;
            }
             
            if (this.ObjSalvarInformacoesDeclaracoes == null || (!this.Edicao && this.tab  <= 6)) {
                this.gravarDados.salvarDadosDeclaracoes = 1;
                return;
            } else {
                await api
                    .post('/PessoaJuridica/declaracoes', this.ObjSalvarInformacoesDeclaracoes)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$store.commit('SET_PJ_SALVAR_INFO_DECLARACOES', null);
                            this.gravarDados.salvarDadosDeclaracoes = 1;
                        }
                    })
                    .catch((error) => {
                        this.$store.commit('SET_PJ_SALVAR_INFO', false);
                        this.gravarDados.salvarDadosDeclaracoes = 2;
                        if(error.response.data.data[0] && error.response.data.data[0].includes('pergunta obrigatória não informada')){

                            const campo = error.response.data.data[0].split(':')[0].trim();

                            this.$swal({
                                icon: 'warning',
                                title: 'Atenção: pergunta obrigatório não informada.',
                                text: `'${campo}*'`,
                            });

                        }else{
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Informações.',
                            text: `${error.response.data.data[0]}`,
                        });
                        }
                    });
            }
        },
        async salvarDadosEndereco() {
            if (!this.salvarInformacoesPJ) {
                return;
            }
             
            if (this.ObjSalvarInformacoesEndereco == null || (!this.Edicao && this.tab  <= 4)) {
                this.gravarDados.salvarDadosEndereco = 1;
                return;
            } else {
                await api
                    .post('/PessoaJuridica/endereco', this.ObjSalvarInformacoesEndereco)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$store.commit('SET_PJ_SALVAR_INFO_ENDERECO', null);
                            this.gravarDados.salvarDadosEndereco = 1;
                            return;
                        }
                    })
                    .catch((error) => {
                        this.gravarDados.salvarDadosEndereco = 2;
                        this.$store.commit('SET_PJ_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Informações.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }

        },
        async salvarDadosBancariosAdicional() {
            if (!this.salvarInformacoesPJ) {
                return;
            }
             
            if (this.ObjSalvarInformacoesBancariasAdicional == null || (!this.Edicao && this.tab  <= 3)) {
                this.gravarDados.salvarDadosBancariosAdicional = 1;
            } else {
                await api
                    .post('/PessoaJuridica/dadosBancarios', this.ObjSalvarInformacoesBancariasAdicional)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$store.commit('SET_PJ_SALVAR_INFO_BANCARIAS_ADICIONAL', null);
                            this.gravarDados.salvarDadosBancariosAdicional = 1;
                        }
                    })
                    .catch((error) => {
                        this.$store.commit('SET_PJ_SALVAR_INFO', false);
                        this.gravarDados.salvarDadosBancariosAdicional = 2;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Informações.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        },
        async salvarDadosBancariosPrincipal() {
            if (!this.salvarInformacoesPJ) {
                return;
            }
             
            if (this.ObjSalvarInformacoesBancarias == null || (!this.Edicao && this.tab  <= 3)) {
                this.gravarDados.salvarDadosBancariosPrincipal = 1;
                return;
            } else {
                await api
                    .post('/PessoaJuridica/dadosBancarios', this.ObjSalvarInformacoesBancarias)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$store.commit('SET_PJ_SALVAR_INFO_BANCARIAS', null);
                            this.gravarDados.salvarDadosBancariosPrincipal = 1;
                        }
                    })
                    .catch((error) => {
                        this.$store.commit('SET_PJ_SALVAR_INFO', false);
                        this.gravarDados.salvarDadosBancariosPrincipal = 2;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Informações.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        },
        async salvarDadosFinanceiro() {
            if (!this.salvarInformacoesPJ) {
                return;
            }
             
            if (this.ObjSalvarInformacoesFinanceiro == null || (!this.Edicao && this.tab  <= 2)) {
                this.gravarDados.salvarDadosFinanceiro = 1;
                return;
            } else {
                const dadosFormatados = { ...this.ObjSalvarInformacoesFinanceiro };
                // Formata cada campo financeiro
                dadosFormatados.FaturamentoMedioMensal = this.formatarValorFinanceiro(dadosFormatados.FaturamentoMedioMensal);
                dadosFormatados.CapitalSocial = this.formatarValorFinanceiro(dadosFormatados.CapitalSocial);
                dadosFormatados.PatrimonioAplicacoesFinanceiras = this.formatarValorFinanceiro(dadosFormatados.PatrimonioAplicacoesFinanceiras);
                dadosFormatados.PatrimonioLiquido = this.formatarValorFinanceiro(dadosFormatados.PatrimonioLiquido);
                dadosFormatados.ValorBensMoveisImoveis = this.formatarValorFinanceiro(dadosFormatados.ValorBensMoveisImoveis);
                await api
                    .post('/PessoaJuridica/dadosFinanceiros', dadosFormatados)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$store.commit('SET_PJ_SALVAR_INFO_FINANCEIRO', null);
                            this.gravarDados.salvarDadosFinanceiro = 1;
                            return;
                        }
                    })
                    .catch((error) => {
                        this.gravarDados.salvarDadosFinanceiro = 2;
                        this.$store.commit('SET_PJ_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Dados Financeiro',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        },
        async salvarComplementoSocios() {
            if (!this.salvarInformacoesPJ) {
                return;
            }
             
            if (this.ObjSalvarInformacoesComplementoSocios == null) {
                this.gravarDados.salvarComplementoSocios = 1;
                return;
            } else {
                var obj = { socios: this.ObjSalvarInformacoesComplementoSocios }
                await api
                    .post('/PessoaJuridica/socios', obj)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$store.commit('SET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS', null);
                            this.$store.dispatch('FETCH_PJ_INFO_COMPLEMENTO_SOCIOS');
                            this.gravarDados.salvarComplementoSocios = 1;
                        }
                    })
                    .catch((error) => {
                        this.gravarDados.salvarComplementoSocios = 2;
                        this.$store.commit('SET_PJ_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Informações.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        },
        async salvarComplementoEmpresa() {
            if (!this.salvarInformacoesPJ) {
                return;
            }
             
            if (this.ObjSalvarInformacoesComplementoEmpresa == null) {
                this.gravarDados.salvarComplementoEmpresa = 1;
                return;
            } else {
                var obj = { empresas: this.ObjSalvarInformacoesComplementoEmpresa }
                await api
                    .post('/PessoaJuridica/empresas', obj)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$store.commit('SET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA', null);
                            this.gravarDados.salvarComplementoEmpresa = 1;
                            return;
                        }
                    })
                    .catch((error) => {
                        this.$store.commit('SET_PJ_SALVAR_INFO', false);
                        this.gravarDados.salvarComplementoEmpresa = 2;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos na aba Informações, em "Empresas coligadas, controladas ou controladoras"',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        },
        executaProximaEtapa(){
            this.tab = this.etapaCadastro;

            if(this.maxTab < this.tab){
                this.maxTab = this.tab;
            }
        },
        async salvar(){
 
                this.salvarComplementoEmpresa();
                this.salvarComplementoSocios();
                this.salvarDadosFinanceiro();
                this.salvarDadosBancariosPrincipal();
                this.salvarDadosBancariosAdicional();
                this.salvarDadosEndereco();
                this.salvarInformacoesUpload();
                this.salvarDadosDeclaracoes();
                this.salvarInformacoesDispensaQuestionario();
                this.salvarQuestionarioAsync();
                if (this.ObjSalvarInformacoesEmpresa == null) {
                    this.gravarDados.salvarInformacoesPJ = 1;
                    return;
                } else {
                    await api
                        .post('/PessoaJuridica/informacaoBasica', this.ObjSalvarInformacoesEmpresa)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.commit('SET_PJ_SALVAR_INFO_EMPRESA', null);
                                this.gravarDados.salvarInformacoesPJ = 1;
                                return;
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarInformacoesPJ = 2;
                            this.$store.commit('SET_PJ_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Informações.',
                                text: `${error.response.data.data[0]}`,
                            });
                        });
                }
        },
        async verificaSePassouPorTodosPassos(){
            this.$store.commit('SET_ETAPA_CONCLUIDA', this.tab);

            var etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 8, 9];

            if(this.nomeEmpresa.toUpperCase() != 'GENIAL'){
              etapasObrigatorias.push(4);
            }
            
            if(!Array.isArray(this.etapasConcluidas)){
                return false;
            }

            const etapasConcluidas = Array.isArray(this.etapasConcluidas)
                    ? this.etapasConcluidas.filter(e => typeof e === 'number')
                    : [];

            const todasEtapasOk = etapasObrigatorias.every(etapa => 
                etapasConcluidas.includes(etapa)
            );


            if(todasEtapasOk){
                return true;
            }else{
                this.$store.commit('SET_ETAPA_CONCLUIDA', this.tab);
                return false;
            }
        }
    },
    watch: {
        salvouTodasAbas(newVal) {
            if (newVal) {
                this.salvarConcluir();
                if(this.solicitouProximaEtapa)
                {
                    this.executaProximaEtapa();
                    this.$store.commit('SET_PJ_SALVAR_INFO', false);
                }
                else if(this.enviarCadastro)
                {
                    this.salvarConcluir();
                }
                this.gravarDados.salvarInformacoesPJ = 0;
                this.gravarDados.salvarComplementoEmpresa = 0;
                this.gravarDados.salvarComplementoSocios = 0;
                this.gravarDados.salvarDadosFinanceiro = 0;
                this.gravarDados.salvarDadosBancariosPrincipal = 0;
                this.gravarDados.salvarDadosBancariosAdicional = 0;
                this.gravarDados.salvarDadosEndereco = 0;
                this.gravarDados.salvarDadosDeclaracoes = 0;
                this.gravarDados.salvarInformacoesUpload = 0;
                this.gravarDados.salvarInformacoesDispensaQuestionario = 0;
                this.gravarDados.salvarQuestionario = 0;

            }
        },
        etapaCadastro() {
            if(this.Edicao)
            {
                this.tab = this.etapaCadastro;
            }
            else if(this.etapaCadastro == 0){
                this.executaProximaEtapa();
            }
            else
            {
                this.solicitouProximaEtapa = true;
            }
        },
        infoEndereco() {
            this.informacoesEndereco = this.infoEndereco;
        },
        infoEmpresa() {
            this.informacoesEmpresa = this.infoEmpresa;
        },
        infoFinanceiras() {
            this.informacoesFinanceiras = this.infoFinanceiras;
        },
        infoDeclaracoes() {
            this.informacoesDeclaracoes = this.infoDeclaracoes;
        },
        enviarCadastro(){
            if(this.enviarCadastro){
                this.$store.commit('SET_PJ_SALVAR_INFO', true);
            }
        },
        async salvarInformacoesPJ() {
            if (this.salvarInformacoesPJ) {
                if(this.BloquearSalvarIsolado)
                {
                    this.$store.commit("SET_MODAL_QUESTIONARIO", false);
                    this.$emit('update:Edicao', false);

                    if(await this.verificaSePassouPorTodosPassos() == false || !this.enviarCadastro){
                        this.$store.commit('SET_PJ_SALVAR_INFO', false);
                        this.$store.commit('SET_ENVIAR_CADASTRO', false)
                        return;
                    }
                    this.$store.commit('SET_ENVIAR_CADASTRO', false);
                    this.$store.commit('SET_FICHA_CONCLUIR', true);
                }else if(this.Edicao && !this.BloquearSalvarIsolado && !this.enviarCadastro){
                    this.$store.commit('SET_PJ_SALVAR_INFO', false);
                    this.$store.commit('SET_ENVIAR_CADASTRO', false)
                    this.$store.commit('SET_MODAL_AVISO', 'ModalConfirmar');
                    this.$emit('update:Edicao', false);
                    this.$store.commit('SET_FICHA_CONCLUIR', true);
                    return;
                }
                
                this.salvar();
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

/* Estilos globais */
body,
html {
    height: 100%;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
}

.link__before {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid;
    max-width: 70px;

}

.site-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    /* Ajuste conforme necessário */
    background-color: #fff;
    /* Ou qualquer cor de fundo que você deseja */
}

.info__resumo {
    display: flex;
    width: 100%;
    padding-bottom: 9px;

    .navegacao {
        display: flex;
        flex-wrap: wrap;

        // .link {
        //     font-size: 14px;
        //     text-align: center;
        //     margin-right: 30px;
        //     margin-top: 20px;
        //     color: #667085;
        //     text-decoration: none;
        //     font-family: 'Inter', sans-serif;
        //     font-weight: 500;

        //     &.first {
        //         text-align: left;
        //     }

        //     &.preenchido {
        //         font-size: 12px;
        //         padding-left: 30px;
        //         font-weight: 500;
        //         position: relative;
        //         text-decoration: none;
        //         // box-shadow: 0 3px 0 #00064F;
        //         color: #12481f;
        //         background-image: url('@/assets/aprovado.png');
        //         /* Atualize com o caminho correto */
        //         background-repeat: no-repeat;
        //         background-position: 10px center;
        //         background-size: 20px 20px;
        //     }

        //     &.active {
        //         font-weight: 500;
        //         position: relative;
        //         text-decoration: none;
        //         // box-shadow: 0 3px 0 #00064F;
        //         color: #00064F;

        //         &::after {
        //             content: '';
        //             /* Necessário para que o pseudo-elemento seja exibido */
        //             position: absolute;
        //             /* Posiciona o pseudo-elemento em relação ao link */
        //             left: 0;
        //             /* Alinha à esquerda do link */
        //             bottom: -9px;
        //             /* Distância do sublinhado em relação à base do texto */
        //             width: 100%;
        //             /* Largura do sublinhado igual à do elemento link */
        //             height: 1px;
        //             /* Espessura do sublinhado */
        //             background-color: #00064F;
        //             /* Cor do sublinhado */
        //         }
        //     }
        // }
    }
}

.logo img {
    height: 32px;
    /* Ajuste conforme o tamanho desejado para o logo */
    width: 142px;
}

.navigation ul {
    list-style: none;
    display: flex;
    gap: 1rem;
    /* Espaço entre os itens de navegação */
}

.navigation li {
    padding: 0.5rem 1rem;
    /* Ajuste conforme necessário */
}

.navigation a {
    text-decoration: none;
    color: #000;
    /* Cor do texto */
}

.navigation a.router-link-active {
    color: #00235C;
    /* Cor quando o link está ativo */
}

/* Estilização específica para o botão de cadastro */
.navigation a.router-link-exact-active {
    background-color: #00235C;
    /* Cor de fundo para o botão de cadastro */
    color: #fff;
    border-radius: 5px;
    /* Raio da borda para fazer os cantos arredondados */
    padding: 0.5rem 1rem;
}

/* Estilos para o container do login */
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    padding-top: 0px;
    border-radius: 10px;
    background-color: white;
    //   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    width: 80%;
    margin-left: 10%;
}

.logomark {
    width: 54px;
    height: 43.2px;
}

.info__headers {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    width: 100%;
    border-bottom: 1px solid #EAECF0;
}

.header {
    width: 100%;
    justify-content: flex-start;
}

.header h2 {
    width: 360px;
    /* Largura do elemento */
    height: 38px;
    /* Altura do elemento */
    font-family: 'Gabarito', sans-serif;
    /* Família da fonte, certifique-se de que 'Gabarito' esteja importada ou substitua pelo nome correto da fonte */
    font-weight: 600;
    /* Peso da fonte semibold */
    font-size: 30px;
    /* Tamanho da fonte */
    line-height: 38px;
    /* Altura da linha */
    text-align: left;
    /* Alinhamento do texto ao centro */
    color: #101828;
    margin-bottom: 0px;
}

.header p {
    font-family: 'Inter', sans-serif;
    /* Família da fonte Inter */
    font-weight: 400;
    /* Peso normal da fonte */
    font-size: 16px;
    /* Tamanho da fonte */
    line-height: 24px;
    /* Altura da linha */
    text-align: center;
    /* Alinhamento do texto ao centro */
    color: #6E6E6E;
    /* Cor do texto em cinza (500) - este é um cinza aproximado, ajuste o código hexadecimal conforme necessário */
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    /* Este é um cinza genérico, ajuste conforme necessário */
    font-size: 16px;
    /* Exemplo de tamanho de fonte, ajuste conforme necessário */
    line-height: 24px;
    /* Exemplo de altura de linha, ajuste conforme necessário */
}

.footer a {
    font-weight: 600;
    /* Para 'Cadastre-se', que parece ser mais destacado */
    color: #101828;
    /* Este é o azul padrão de links, ajuste conforme necessário */
    text-decoration: none;
    /* Para sublinhar o link */
}

/* Aplicando estilos de fonte */
button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}

.entrar-button {
    color: #667085;
    background: white;
}

input {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    /* Ajuste para a linha de altura */
    border: 1px solid #ccc;
    border-radius: 8px;
    /* Arredondamento dos inputs */
    box-sizing: border-box;
    /* Garante que o padding não adicione largura extra */
    width: 100%;
    /* Para garantir que os inputs ocupem toda a largura do container */
}

.erroBorder {
    border: 1px solid #E73D3D !important;
    margin-bottom: 0px;
}

.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
}

/* Estilos para os rótulos (labels) do formulário */
.form .input-field label {
    font-family: 'Inter', sans-serif;
    /* Família da fonte Inter */
    font-weight: 500;
    /* Peso médio da fonte */
    font-size: 14px;
    /* Tamanho da fonte */
    line-height: 20px;
    /* Altura da linha */
    color: #344054;
    /* Cor do texto em cinza escuro */
}

/* Estilos para o formulário */
form {
    display: flex;
    flex-direction: column;
}

/* Estilos para os inputs */
input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

/* Botão de entrar */
button {
    padding: 10px;
    background-color: #00235C;
    ;
    color: white;
    border: none;
    border-radius: 4px;
    text-align: center;
}

/* Media query para telas menores */
@media (max-width: 600px) {
    .login-container {
        margin: 20px;
        padding: 10px;
    }

    input,
    button {
        margin-bottom: 10px;
    }
}

h2 {
    text-align: center;
    margin-bottom: 20px;
}

.forgot-password {
    font-family: 'Inter', sans-serif;
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
    color: #00064F;
    text-decoration: none;
}

.signup {
    text-align: center;
    margin-top: 20px;
}

.signup a {
    color: blue;
    text-decoration: none;
}
</style>